import React, { useEffect, useContext } from "react";

import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Grid,
} from "@material-ui/core";

import Btn from "../../../../components/buttons/Btn";

import { VendaRapidaContext } from "../contexts/VendaRapidaContext";
import SelectErp from "../../../../components/basics/SelectErp";
import TextFieldErp from "../../../../components/basics/TextFieldErp";
import useVendaRapidaController from "../controllers/VendaRapidaController";
import MaskService from "../../../../utils/mask/maskService";
import Cmc7 from "../../../../utils/Cmc7Validator/Cmc7";
import { formatDate } from "../../../../utils/formatDate";

let today = new Date();

today = formatDate({
  date: today,
  separator: "-",
  format: "yyyy-mm-dd",
});

const ModalChequeCartao = () => {
  const {
    modalChequeCartaoOpen,
    cardBandeirasList,
    setModalChequeCartaoOpen,
    cardAuthorizationNumber,
    setCardAuthorizationNumber,
    cardDocnsu,
    setCardDocnsu,
    cardErrors,
    cardSelectedBandeira,
    setCardSelectedBandeira,
    cardSelectedOperadora,
    setCardSelectedOperadora,
    isCheck,
    checkBanda,
    setCheckBanda,
    checkNumber,
    setCheckNumber,
    checkDepositDate,
    setCheckDepositDate,
    checkCpfCnpj,
    setCheckCpfCnpj,
    checkBankCode,
    setCheckBankCode,
    checkAgency,
    setCheckAgency,
    checkCurrentAccount,
    setCheckCurrentAccount,
    checkAccountHolder,
    setCheckAccountHolder,
    checkErrors,
    cardOperadorasList,
    editRowCheckOrCard,
  } = useContext(VendaRapidaContext);

  const { addPaymentRowCheckOrCard, editPaymentRow, resetModalCardOrCheck } =
    useVendaRapidaController();

  const handleClose = () => {
    resetModalCardOrCheck();
    setModalChequeCartaoOpen(false);
  };

  const handleSave = () => {
    addPaymentRowCheckOrCard(handleClose);
  };

  const handleEdit = (idtipopagto, index) => {
    editPaymentRow(idtipopagto, index);
  };

  let title = isCheck
    ? "Insira as informações do cheque"
    : "Insira as informações do cartão";

  useEffect(() => {
    if (editRowCheckOrCard?.cartao) {
      const { cartao } = editRowCheckOrCard;

      setCardAuthorizationNumber(cartao.sn_autorizacao ?? "");
      setCardDocnsu(cartao.sn_docnsu ?? "");
      setCardSelectedOperadora(
        cardOperadorasList.find((e) => e.id === cartao.id_operadora) || ""
      );
      setCardSelectedBandeira(
        cardBandeirasList.find((e) => e.id === cartao.id_bandeira) || ""
      );
    } else if (editRowCheckOrCard?.cheque) {
      const { cheque } = editRowCheckOrCard;
      let maskedCpf;

      if (cheque.sn_cpfcgc.length === 11)
        maskedCpf = MaskService.toMask("cpf", cheque.sn_cpfcgc);
      if (cheque.sn_cpfcgc.length === 14)
        maskedCpf = MaskService.toMask("cnpj", cheque.sn_cpfcgc);

      setCheckCpfCnpj(maskedCpf ?? "");
      setCheckNumber(cheque.sn_numero);
      setCheckDepositDate(cheque.dt_datadeposito.replaceAll("/", "-"));
      setCheckBankCode(cheque.sn_banco ?? "");
      setCheckAgency(cheque.sn_agencia ?? "");
      setCheckCurrentAccount(cheque.sn_conta ?? "");
      setCheckAccountHolder(cheque.sn_correntista ?? "");
    }
    // eslint-disable-next-line
  }, [editRowCheckOrCard]);

  useEffect(() => {
    let mask = checkCpfCnpj.length > 14 ? "cnpj" : "cpf";
    const newCheckCpfCnpj = MaskService.toMask(mask, checkCpfCnpj);

    setCheckCpfCnpj(newCheckCpfCnpj);
    // eslint-disable-next-line
  }, [checkCpfCnpj]);

  useEffect(() => {
    // 001058360180389955600053280715
    // 237021540180000395202022288829
    if (checkBanda.length === 30) {
      const check = new Cmc7(checkBanda);

      setCheckNumber(check.numeroCheque ?? "");
      setCheckBankCode(check.banco ?? "");
      setCheckAgency(check.agencia ?? "");
      setCheckCurrentAccount(`${check.conta}${check.digitoConta}` ?? "");
    }
    // eslint-disable-next-line
  }, [checkBanda]);

  useEffect(() => {
    if (checkDepositDate === "") setCheckDepositDate(today);
    // eslint-disable-next-line
  }, [checkDepositDate]);

  return (
    <Dialog open={modalChequeCartaoOpen} fullWidth maxWidth="sm">
      <DialogTitle id="customized-dialog-title" children={title} />
      <DialogContent>
        {!isCheck ? (
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} lg={6}>
              <TextFieldErp
                label="Número de autorização"
                value={cardAuthorizationNumber}
                setValue={setCardAuthorizationNumber}
                error={cardErrors.cardAuthorizationNumber ? true : false}
                helperText={cardErrors.cardAuthorizationNumber || ""}
                descriptionField="descricao"
              />
            </Grid>
            <Grid item xs={12} sm={6} lg={6}>
              <TextFieldErp
                label="DOC/NSU"
                descriptionField="descricao"
                value={cardDocnsu}
                setValue={setCardDocnsu}
                error={cardErrors.cardDocnsu ? true : false}
                helperText={cardErrors.cardDocnsu || ""}
              />
            </Grid>
            <Grid item xs={12} sm={6} lg={6}>
              <SelectErp
                label="Operadora"
                optionsList={cardOperadorasList}
                descriptionField="sn_descricao"
                value={cardSelectedOperadora}
                setValue={setCardSelectedOperadora}
                error={cardErrors.cardSelectedOperadora ? true : false}
                helperText={cardErrors.cardSelectedOperadora || ""}
              />
            </Grid>
            <Grid item xs={12} sm={6} lg={6}>
              <SelectErp
                label="Bandeira"
                optionsList={cardBandeirasList}
                value={cardSelectedBandeira}
                setValue={setCardSelectedBandeira}
                error={cardErrors.cardSelectedBandeira ? true : false}
                helperText={cardErrors.cardSelectedBandeira || ""}
                descriptionField="sn_descricao"
              />
            </Grid>
          </Grid>
        ) : (
          <>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6} lg={12}>
                <TextFieldErp
                  label="Banda"
                  value={checkBanda}
                  setValue={setCheckBanda}
                  error={checkErrors.checkBanda ? true : false}
                  helperText={checkErrors.checkBanda || ""}
                />
              </Grid>
              <Grid item xs={12} sm={6} lg={3}>
                <TextFieldErp
                  label="Nº Cheque"
                  descriptionField="descricao"
                  value={checkNumber}
                  setValue={setCheckNumber}
                  error={checkErrors.checkNumber ? true : false}
                  helperText={checkErrors.checkNumber || ""}
                />
              </Grid>
              <Grid item xs={12} sm={6} lg={4}>
                <TextFieldErp
                  label="Data depósito"
                  descriptionField="descricao"
                  type="date"
                  value={checkDepositDate}
                  setValue={setCheckDepositDate}
                  error={checkErrors.checkDepositDate ? true : false}
                  helperText={checkErrors.checkDepositDate || ""}
                />
              </Grid>
              <Grid item xs={12} sm={6} lg={5}>
                <TextFieldErp
                  label="CPF/CNPJ"
                  value={checkCpfCnpj}
                  setValue={setCheckCpfCnpj}
                  error={checkErrors.checkCpfCnpj ? true : false}
                  helperText={checkErrors.checkCpfCnpj || ""}
                />
              </Grid>
              <Grid item xs={12} sm={6} lg={3}>
                <TextFieldErp
                  label="Cód. Banco"
                  value={checkBankCode}
                  setValue={setCheckBankCode}
                  // error={checkErrors.cardSelectedOperadora ? true : false}
                  // helperText={checkErrors.cardSelectedOperadora || ""}
                />
              </Grid>
              <Grid item xs={12} sm={6} lg={2}>
                <TextFieldErp
                  label="Agência"
                  descriptionField="descricao"
                  value={checkAgency}
                  setValue={setCheckAgency}
                  error={checkErrors.checkAgency ? true : false}
                  helperText={checkErrors.checkAgency || ""}
                />
              </Grid>
              <Grid item xs={12} sm={6} lg={3}>
                <TextFieldErp
                  label="Conta Corrente"
                  descriptionField="descricao"
                  value={checkCurrentAccount}
                  setValue={setCheckCurrentAccount}
                  error={checkErrors.checkCurrentAccount ? true : false}
                  helperText={checkErrors.checkCurrentAccount || ""}
                />
              </Grid>
              <Grid item xs={12} sm={6} lg={4}>
                <TextFieldErp
                  label="Correntista"
                  value={checkAccountHolder}
                  setValue={setCheckAccountHolder}
                  error={checkErrors.checkAccountHolder ? true : false}
                  helperText={checkErrors.checkAccountHolder || ""}
                />
              </Grid>
            </Grid>
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Btn
          onClick={
            editRowCheckOrCard
              ? () =>
                  handleEdit(
                    editRowCheckOrCard?.idtipopagto,
                    editRowCheckOrCard?.index
                  )
              : handleSave
          }
          bgcolor="primary"
          hovercolor="orange"
          label="Salvar"
        />
        <Btn
          onClick={handleClose}
          bgcolor="grey"
          hovercolor="blue"
          label="Cancelar"
        />
      </DialogActions>
    </Dialog>
  );
};

export default ModalChequeCartao;
